/**
 * Do not edit this file manually.
 *
 * This file contains the following:
 * - Record interface
 * - Records interface
 * - records object
 * - enums for subCategoryIds, isoCountryCodes, theme
 *
 *
 * This file is generated by build-scripts/cartography/carto-gen.js
 */
export enum SubCategoryId {
  buddhist = 'buddhist',
  shinto = 'shinto',
  prefectural_office = 'prefectural_office',
  town_village_office = 'town_village_office',
  ward_office = 'ward_office',
  bridge = 'bridge',
  gradient = 'gradient',
  tunnel = 'tunnel',
  interchange = 'interchange',
  interchange_toll = 'interchange_toll',
  intersection = 'intersection',
  junction = 'junction',
  ramp = 'ramp',
  smart_interchange = 'smart_interchange',
}

export enum IsoCountryCode {
  JP = 'JP',
  AT = 'AT',
  BE = 'BE',
  CZ = 'CZ',
  DE = 'DE',
  DK = 'DK',
  FI = 'FI',
  HK = 'HK',
  IT = 'IT',
  NO = 'NO',
  SE = 'SE',
  CY = 'CY',
  EE = 'EE',
  ES = 'ES',
  FK = 'FK',
  FR = 'FR',
  GB = 'GB',
  GG = 'GG',
  GI = 'GI',
  GR = 'GR',
  GS = 'GS',
  HR = 'HR',
  IE = 'IE',
  IM = 'IM',
  JE = 'JE',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  MT = 'MT',
  NL = 'NL',
  PT = 'PT',
  SH = 'SH',
  SI = 'SI',
  SK = 'SK',
  TA = 'TA',
}

export enum Theme {
  dark = 'dark',
  hybrid = 'hybrid',
  light = 'light',
}

export interface Record {
  fileName: string
  genericIconography: string
  categoryClass: string
  sprites: {
    assets: string[]
    icons: string[]
  }
  tokens: string[]
}

export interface Records {
  [key: string]: Record
}
